module.exports = __webpack_public_path__ + "5630addb919bb22549c6715d2594ac82.ico";